<div class="characteristics-container">
  @if (this.data.servingTime) {
    <h3 mat-dialog-title class="header-container">Update Serving Time</h3>
  } @else {
    <h3 mat-dialog-title class="header-container">Add Serving Time</h3>
  }

  <div class="sub-head pl-4">Set a time range and name it for quick selection in the future.</div>

  <form [formGroup]="servingTimeForm">
    <mat-dialog-content class="pt-3 pb-4">
      <div class="d-flex flex-column mb-3 pt-2">
        <div class="">
          <label class="form-label pl-0"><span class="status-span">*</span>Name:</label>
        </div>
        <div class="mt-1">
          <input
            type="text"
            class="form-control"
            placeholder="Eg: Enter the new serving time"
            formControlName="name"
          />
          @if (
            servingTimeForm.get('name')?.errors?.['required'] &&
            (servingTimeForm.get('name')?.touched || servingTimeForm.get('name')?.dirty)
          ) {
            <div class="d-flex mt-2 errorText gap-2">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>Serving Time Name cannot be empty.</p>
            </div>
          }
          @if (servingTimeForm.get('name')?.errors?.['minlength']) {
            <div class="d-flex mt-2 errorText gap-2">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>Name must be at least 3 characters long.</p>
            </div>
          }
          @if (servingTimeForm.get('name')?.errors?.['maxlength']) {
            <div class="d-flex mt-2 errorText gap-2">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>Name can not exceed 20 characters.</p>
            </div>
          }
          @if (servingTimeForm.get('name')?.errors?.['uniqueName']) {
            <div class="d-flex mt-2 errorText gap-2">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>Name can not be duplicate.</p>
            </div>
          }
        </div>
        <div class="row">
          <div class="col-6">
            <div class="mt-3">
              <label class="form-label pl-0"><span class="status-span">*</span>Start Time:</label>
            </div>
            <div class="mt-1">
              <input
                type="time"
                class="form-control"
                placeholder="Enter Start time"
                step="60"
                formControlName="start_time"
              />
            </div>
            @if (
              servingTimeForm.get('start_time')?.errors?.['required'] &&
              (servingTimeForm.get('start_time')?.touched ||
                servingTimeForm.get('start_time')?.dirty)
            ) {
              <div class="d-flex mt-2 errorText gap-2">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p>Start Time cannot be empty.</p>
              </div>
            }
          </div>
          <div class="col-6">
            <div class="mt-3">
              <label class="form-label pl-0"><span class="status-span">*</span>End Time:</label>
            </div>
            <div class="mt-1">
              <input
                type="time"
                class="form-control"
                placeholder="Enter End time"
                formControlName="end_time"
              />
            </div>
            @if (
              servingTimeForm.get('end_time')?.errors?.['required'] &&
              (servingTimeForm.get('end_time')?.touched || servingTimeForm.get('end_time')?.dirty)
            ) {
              <div class="d-flex mt-2 errorText gap-2">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p>End time cannot be empty.</p>
              </div>
            }
          </div>
          @if (servingTimeForm.errors?.['timeRangeInvalid']) {
            <div class="d-flex mt-2 errorText gap-2">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p>Start time must be less than end time.</p>
            </div>
          }
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="justify-content-end gap-3 border-top pt-3 pb-3 pr-4">
      <button class="btn btn-light" mat-dialog-close>Cancel</button>
      @if (this.data.servingTime) {
        <button
          type="submit"
          class="btn btn-dark"
          [disabled]="servingTimeForm.invalid || servingTimeForm.get('name')?.value == ''"
          (click)="addServingTime()"
        >
          Update
        </button>
      } @else {
        <button
          type="submit"
          class="btn btn-dark"
          [disabled]="servingTimeForm.invalid || servingTimeForm.get('name')?.value == ''"
          (click)="addServingTime()"
        >
          Add Serving Time
        </button>
      }
    </mat-dialog-actions>
  </form>
</div>
